import ErrorReportService from '@root/core/src/services/error-report-service';
import ExpectedErrorResponseError from '@root/core/src/api/expected-error-response-error';
import NetworkConnectivityError from '@root/core/src/networking/network-connectivity-error';
import UnexpectedErrorResponseError from '@root/core/src/api/unexpected-error-response-error';

export default class NetworkService {
  static handleNetworkError(error, params, stack, isSafe) {
    if (error instanceof ExpectedErrorResponseError) { return; }

    const errorToReport = new Error(error.message || error);
    errorToReport.stack = stack;
    errorToReport.additionalData = {
      fetchBody: params,
    };

    if (isSafe) {
      if (error instanceof NetworkConnectivityError) { return; }

      ErrorReportService.reportError({
        error: errorToReport,
        caughtAt: 'network-error',
        additionalData: {
          fetchBody: params,
        },
      });
    } else {
      throw error;
    }
  }
}

export class NetworkResult {
  constructor(data, error) {
    this._data = data;
    this._error = error;
  }

  get data() {
    return this._data;
  }

  get error() {
    return this._error;
  }

  get isSuccess() {
    return !this.error;
  }

  get isError() {
    return !this.isSuccess;
  }
}

class NetworkRequest {
  constructor(request, params, isSafe) {
    this._request = request;
    this._params = params;
    this._stack = new Error().stack;
    this._isSafe = isSafe;
  }

  async request() {
    let data, error;
    try {
      data = await this._request(this._params);
    } catch (err) {
      error = err || new Error('request promise was rejected without throwing');
      if (!(error instanceof ExpectedErrorResponseError) && !(error instanceof UnexpectedErrorResponseError)) {
        error = new NetworkConnectivityError(error.message || error);
      }

      NetworkService.handleNetworkError(error, this._params, this._stack, this._isSafe);
    }

    return new NetworkResult(data, error);
  }
}

NetworkService.request = function (request, params) {
  return new NetworkRequest(request, params, false).request();
};

NetworkService.safeRequest = function (request, params) {
  return new NetworkRequest(request, params, true).request();
};

